import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Heart, Mail } from 'lucide-react';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-amber-50 via-white to-orange-50 border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-3 md:mb-4">
          {/* Sobre */}
          <div>
            <div className="flex items-center gap-2 mb-2">
              <img 
                src="/logo.png" 
                alt="mAI Recipes" 
                className="footer-logo w-8 h-8 md:w-8 md:h-8 object-contain"
                style={{ maxWidth: '48px !important', maxHeight: '48px !important' }}
              />
              <h3 className="font-bold text-amber-900 text-sm md:text-base">mAI Recipes</h3>
            </div>
            <p className="text-xs md:text-sm text-gray-600">
              {t('footer.description')}
            </p>
          </div>

          {/* Links Rápidos */}
          <div>
            <h4 className="font-semibold text-amber-900 mb-2 text-sm md:text-base">{t('footer.quickLinks')}</h4>
            <ul className="flex flex-wrap gap-x-3 gap-y-1 md:flex-col md:space-y-1 text-xs md:text-sm text-gray-600">
              <li>
                <a href="/" className="hover:text-orange-600 transition-colors">{t('common.home')}</a>
              </li>
              <li>
                <a href="/subscription" className="hover:text-orange-600 transition-colors">{t('footer.premiumPlans')}</a>
              </li>
              <li>
                <a href="/ai-generator" className="hover:text-orange-600 transition-colors">{t('footer.aiGenerator')}</a>
              </li>
              <li>
                <a href="/chat-assistant" className="hover:text-orange-600 transition-colors">{t('footer.assistant')}</a>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h4 className="font-semibold text-amber-900 mb-2 text-sm md:text-base">{t('footer.support')}</h4>
            <ul className="space-y-1 text-xs md:text-sm text-gray-600">
              <li className="flex items-center gap-2">
                <Mail className="w-3 h-3 md:w-4 md:h-4" />
                <span>support@mai-recipes.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 pt-3 md:pt-4">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
            {/* Copyright */}
            <div className="flex items-center gap-3">
              <div 
                className="text-xs md:text-sm text-gray-600 cursor-pointer hover:text-orange-600 transition-colors"
                onClick={() => navigate('/copyright')}
              >
                © {currentYear} mAI Recipes. {t('footer.copyright')}
              </div>
              
              <span className="text-gray-400">|</span>
              
              <div
                className="text-xs md:text-sm text-gray-600 cursor-pointer hover:text-orange-600 transition-colors font-medium"
                onClick={() => navigate('/contact')}
              >
                {t('contact.title')}
              </div>
            </div>

            {/* Feito com amor */}
            <div className="flex items-center gap-1 text-xs md:text-sm text-gray-600">
              <span>{t('footer.madeWith')}</span>
              <Heart className="w-3 h-3 md:w-4 md:h-4 text-red-500 fill-red-500" />
              <span>{t('footer.andAI')}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
